import React from 'react';
import KnowledgeBase, { LibraryTab } from './components/KnowledgeBase';

export type GuideTab = LibraryTab;

interface Props {
  onClose:     () => void;
  initialTab?: GuideTab;
}

export default function UserGuideModal({ onClose, initialTab = 'guide' }: Props): React.JSX.Element {
  return <KnowledgeBase onClose={onClose} initialTab={initialTab} />;
}
